import { Box, Button, Grid, TextField, Typography, } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from "yup";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DoneIcon from '@mui/icons-material/Done';
import "./MeterChangeRequestForm.scss";
import { cfpBaseUrl } from '../../../network/urls';
import { useLocation } from 'react-router';
import { CircularProgress, Backdrop } from '@mui/material';
import Error from '../../../components/error/error';
import { documentValidation, isImage, isPdf } from '../../../services/Functions';
import { useSelector } from 'react-redux';
import { documentExtensions } from '../../../utils/PortalName';

const MeterChangeRequestUpdateDocuments = () => {

    const initialValues = {
        // Required Documents Initial Values
        iv_last_paid_bill: null,
        iv_police_report: null,
    }
    const [error, setError] = useState(false);
    // Documents states
    const [lastPaidBill, setLastPaidBill] = useState('');
    const [policeReport, setPoliceReport] = useState('');
    // Thumbnail states
    const [lastPaidBillThumbnail, setLastPaidBillThumbnail] = useState('');
    const [policeReportThumbnail, setPoliceReportThumbnail] = useState('');
    // File Name
    const [lastPaidBillFileName, setLastPaidBillFileName] = useState('');
    const [policeReportFileName, setPoliceReportFileName] = useState('');
    const [viewBackdrop, setViewBackdrop] = useState(false);

    const [meterChangeType, setMeterChangeType] = useState(1);

    const { state } = useLocation();
    const { dialogRowData } = state;
    const [dialogRowDataLocal, setDialogRowDataLocal] = useState();
    let { token, code: officeCode, hierarchy: userHierarchy, showAllApplicationsFlag, userId } = useSelector((state) => state.auth)

    const navigate = useNavigate();

    const errorCloses = () => {
        setError('');
    }

    useEffect(() => {
        if (dialogRowData) {
            let dialogData = dialogRowData
            setDialogRowDataLocal(dialogData)
        }
    }, [dialogRowData])

    useEffect(() => {
        if (dialogRowData) {
            setMeterChangeType(dialogRowData.meterChangeType)
        }
        if (dialogRowData.lastBillImage) {
            mcrFormik.values.iv_last_paid_bill = dialogRowData.lastBillImage
            setLastPaidBillThumbnail(dialogRowData.lastBillImage)
        }
        if (dialogRowData.policeReportImage) {
            mcrFormik.values.iv_police_report = dialogRowData.policeReportImage
            setPoliceReportThumbnail(dialogRowData.policeReportImage)
        }

    }, [dialogRowData])

    const mcrFormik =
        useFormik({
            initialValues,
            validationSchema: Yup.object({
                // Required Documents Validation
                iv_last_paid_bill: Yup.mixed().required('Please upload last bill in jpg, jpeg, png or pdf format.'),
                policeReportImage: Yup.mixed().when('meterChangeType', {
                    is: (value) => (meterChangeType === 3),
                    then: Yup.mixed().required('Please upload police report in jpg, jpeg, png or pdf format.'),
                    otherwise: Yup.mixed(),
                }),
            }),
            onSubmit: async (values, { resetForm }) => {
                setViewBackdrop(true);
                var formdata = new FormData();
                formdata.append("applicationId", dialogRowData.applicationId);
                formdata.append("lastModifiedBy", userId);
                // formdata.append("applicantCNIC", dialogRowData.applicantCNIC);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);;
                if (lastPaidBillThumbnail) {
                    formdata.append("lastBillImage", lastPaidBillThumbnail);
                }
                else {
                    formdata.append("lastBillImage", '');
                }
                if (policeReportThumbnail) {
                    formdata.append("policeReportImage", policeReportThumbnail);
                }
                else {
                    formdata.append("policeReportImage", '');
                }

                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };

                await fetch(cfpBaseUrl + "changeOfMeterRequest/updateChangeOfMeterRequestImg", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            var formdata = new FormData();
                            formdata.append("applicationId", dialogRowData.applicationId);
                            const myHeaders = new Headers();
                            myHeaders.append("Authorization", token);;
                            formdata.append("lastBillImageFlag", "");
                            formdata.append("policeReportImageFlag", "");

                            var requestOptions = {
                                method: 'POST',
                                body: formdata,
                                headers: myHeaders,
                                redirect: 'follow',
                            };

                            fetch(cfpBaseUrl + "changeOfMeterRequest/changeOMRImagesApproval", requestOptions)
                                .then(response => response.json())
                                .then(result => {
                                    if (result.status === "200") {
                                        var formdata = new FormData();
                                        formdata.append("applicationId", dialogRowData.applicationId);
                                        formdata.append("objectionStatus", 0);
                                        formdata.append("remarks", "Documents Reuploaded");
                                        formdata.append("remarksDetail", "-");
                                        formdata.append("lastModifiedBy", userId);
                                        const myHeaders = new Headers();
                                        myHeaders.append("Authorization", token);;
                                        var requestOptions = {
                                            method: 'POST',
                                            body: formdata,
                                            headers: myHeaders,
                                            redirect: 'follow',
                                        };
                                        fetch(cfpBaseUrl + "comman/changeObjectionStatus", requestOptions)
                                            .then(response => response.json())
                                            .then(result => {
                                                if (result.status === '200') {
                                                    setTimeout(() => {
                                                        navigate('/meter-change-request-table')
                                                    }, 2000)
                                                }
                                                else {
                                                }
                                            })
                                            .catch(error => console.log('error', error));
                                    }
                                })
                                .catch(error => console.log('error', error));
                        }
                        else {
                            setViewBackdrop(false)
                        }
                    })
                    .catch(error => {
                        setViewBackdrop(false)
                        console.log(error);
                    });
            }
        })

    //Function to set states of documents
    const LastPaidBill = (event) => {
        mcrFormik.handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            setLastPaidBillFileName(fileName)
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "LastBillDocument." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setLastPaidBill(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setLastPaidBillThumbnail(e.target.result);
                    // setPropertyDocumentsBase64(e.target.result.split(',')[1])
                };

                reader.readAsDataURL(file);

            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const PoliceReport = (event) => {
        // console.log('in applicant cnic functiuon')
        mcrFormik.handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            setPoliceReportFileName(fileName)
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            // console.log(extension, 'Printing Extension');
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "PoliceReport." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setPoliceReport(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setPoliceReportThumbnail(e.target.result);
                    // setPropertyDocumentsBase64(e.target.result.split(',')[1])
                };

                reader.readAsDataURL(file);

            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const getMeterChangeReason = (x) => {
        switch (x) {
            case 1:
                return 'No Display';
            case '1':
                return 'No Display';
            case 2:
                return 'Meter Terminal Burnt';
            case '2':
                return 'Meter Terminal Burnt';
            case 3:
                return 'Meter Stolen';
            case '3':
                return 'Meter Stolen';
            default:
                return 'Reason'
        }
    }

    return (
        <>
            <Grid container className='meter-change-request'>
                <Box className='mcContainer'>
                    <Typography variant='h6' className='heading'>
                        Meter Change Request Form
                    </Typography>
                    <Box className="progressBarBackground" >
                        <Box className="progressBarContainer">
                            <Box className="pbDocGroup">
                                <Typography className="badge">
                                    {
                                        lastPaidBill
                                            ?
                                            <Box className='backgroundAttached'>
                                                <DoneIcon className='icon' />
                                            </Box> :
                                            <p className='backgroundUnAttached'>1</p>
                                    }
                                </Typography>
                                <Typography className='badgeText'>Last Paid Bill</Typography>
                            </Box>
                            {
                                meterChangeType == 3 &&
                                <Box className="pbDocGroup">
                                    <Typography className="badge">
                                        {
                                            policeReport
                                                ?
                                                <Box className='backgroundAttached'>
                                                    <DoneIcon className='icon' />
                                                </Box> :
                                                <p className='backgroundUnAttached'>2</p>
                                        }
                                    </Typography>
                                    <Typography className='badgeText'>Police Report</Typography>
                                </Box>
                            }
                        </Box>
                    </Box>
                    <form className='ncform'>
                        <Typography variant="h6" className='groupTitle' >
                            Application Details
                        </Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <Typography className='fieldLabel' > Application Id</Typography>
                                <TextField
                                    required
                                    type='text'
                                    name="iv_applied_load"
                                    value={dialogRowData.applicationId}
                                    disabled
                                    id="iv_applied_load"
                                    className='textInputField'
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className='fieldLabel' >  Meter Change Reason</Typography>
                                <TextField
                                    autoWidth={false}
                                    value={getMeterChangeReason(dialogRowData.meterChangeType)}
                                    disabled
                                    className='textInputField'
                                    name="iv_connection_type"
                                    id="iv_connection_type"
                                />
                            </Grid>
                        </Grid>
                        <Typography variant="h6" className='groupTitle'>
                            Documents
                        </Typography>
                        <Grid container spacing={1} className='documentsContainer' >
                            <Grid item lg='2' >
                                <Typography className='documentLabel' >1- Last Bill.</Typography>
                                <Box className='documentError'>{((mcrFormik.errors.iv_last_paid_bill && mcrFormik.touched.iv_last_paid_bill) || (mcrFormik.errors.iv_applicant_cnic_document_back && mcrFormik.touched.iv_applicant_cnic_document_back)) ? (mcrFormik.errors.iv_last_paid_bill) : null}</Box>
                            </Grid>
                            <Grid item lg='2'>
                                {
                                    dialogRowData.lastBillImage ?
                                        <Grid container>
                                            <Grid item sm={6}>
                                                <img src={lastPaidBillThumbnail} style={{ width: '50%' }} />
                                            </Grid>
                                            {
                                                (!dialogRowData.lastBillImageFlag || dialogRowData.lastBillImageFlag === -1) &&
                                                <Grid item sm={6}>
                                                    <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                        Change
                                                        <input hidden accept={documentExtensions} id='iv_last_paid_bill' name='iv_last_paid_bill' type="file" onChange={LastPaidBill} />
                                                    </Button>
                                                </Grid>
                                            }
                                        </Grid>
                                        :
                                        lastPaidBill ?
                                            <>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setLastPaidBill('') }} />}  >
                                                    {lastPaidBillThumbnail && <img src={lastPaidBillThumbnail} alt="Applicant CNIC" width="50" />}
                                                </Button>
                                            </>
                                            :
                                            <>
                                                <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />} className='btn'>
                                                    Front
                                                    <input hidden accept={documentExtensions} id='iv_last_paid_bill' name='iv_last_paid_bill' type="file" onChange={LastPaidBill} />
                                                </Button>
                                            </>
                                }
                            </Grid>

                            {(dialogRowData.meterChangeType === 3 || dialogRowData.meterChangeType === "3") &&
                                <>
                                    <Grid item lg='2' >
                                        <Typography className='documentLabel' >2- Police Report.</Typography>
                                        <Box className='documentError'>{((mcrFormik.errors.iv_police_report && mcrFormik.touched.iv_police_report) || (mcrFormik.errors.iv_owner_cnic_document_back && mcrFormik.touched.iv_owner_cnic_document_back)) ? (mcrFormik.errors.iv_police_report) : null}</Box>
                                    </Grid>
                                    <Grid item lg='2'>
                                        {
                                            dialogRowData.policeReportImage ?
                                                <Grid container>
                                                    <Grid item sm={6}>
                                                        <img src={policeReportThumbnail} style={{ width: '50%' }} />
                                                    </Grid>
                                                    {
                                                        (!dialogRowData.policeReportImageFlag || dialogRowData.policeReportImageFlag === -1) &&
                                                        <Grid item sm={6}>
                                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                                Change
                                                                <input hidden accept={documentExtensions} id='iv_police_report' name='iv_police_report' type="file" onChange={PoliceReport} />
                                                            </Button>
                                                        </Grid>
                                                    }
                                                </Grid>
                                                :
                                                policeReport ?
                                                    <>
                                                        <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setPoliceReport('') }} />}  >
                                                            {policeReportThumbnail && <img src={policeReportThumbnail} alt="Police Report" width="50" />}
                                                        </Button>
                                                    </>
                                                    :
                                                    <>
                                                        <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />} className='btn' >
                                                            Upload
                                                            <input hidden accept={documentExtensions} id='iv_police_report' name='iv_police_report' type="file" onChange={PoliceReport} />
                                                        </Button>
                                                    </>
                                        }
                                    </Grid>
                                </>
                            }
                        </Grid>
                        {
                            error &&
                            <Error
                                error={error}
                                onClose={() => errorCloses()}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                            />
                        }
                        <Box sx={{ marginTop: '18%', textAlign: 'right' }}>
                            <Button sx={{ width: '10%', marginLeft: '1%', marginBottom: '1%' }} variant="contained" component="label" type='submit' onClick={mcrFormik.handleSubmit} >
                                Submit
                            </Button>
                        </Box>
                    </form >
                </Box >
            </Grid >

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}

export default MeterChangeRequestUpdateDocuments
